import classNames from 'classnames';
import useCombinedRefs from 'hooks/use-combined-refs';
import * as React from 'react';

import styles from './style.module.css';

interface Props
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'style' | 'className'
  > {
  startEnhancer?: React.ReactNode;
  endEnhancer?: React.ReactNode;
  style?: {
    root?: React.CSSProperties;
    input?: React.CSSProperties;
  };
  className?: {
    root?: string;
    input?: string;
  };
}

const DefaultInput = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  const innerRef = React.useRef<HTMLInputElement | null>(null);
  const combinedRef: any = useCombinedRefs(ref, innerRef);
  const [isFocused, setIsFocused] = React.useState(false);
  const {
    className,
    onFocus,
    onBlur,
    style,
    startEnhancer,
    endEnhancer,
    ...rest
  } = props;

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={classNames(
        styles.container,
        className?.root,
        isFocused && styles.containerFocus,
      )}
      style={style?.root}
      onClick={(e) => {
        e.stopPropagation();
        if (!rest.disabled) {
          setIsFocused(true);
          combinedRef.current?.focus();
        }
      }}
    >
      {startEnhancer}
      <input
        {...rest}
        //@ts-ignore
        ref={combinedRef}
        style={style?.input}
        onFocus={(event) => {
          onFocus?.(event);
          setIsFocused(true);
        }}
        onBlur={(event) => {
          onBlur?.(event);
          setIsFocused(false);
        }}
        className={classNames(styles.input, className?.input)}
      />
      {endEnhancer}
    </div>
  );
});

DefaultInput.displayName = 'Input';

export default DefaultInput;
